import React from 'react';

function VisibleCheckBox({ label = '', value = false, toggleValue = () => {} }) {
    return (
        <div className="w-full">
            <div className={`flex flex-row items-center cursor-pointer my-2`}>
                <div className="border-[1.5px] border-black rounded-full h-[18px] w-[18px] flex items-center justify-center" onClick={() => toggleValue()}>
                    {value && <div className="rounded-full h-[10px] w-[10px] bg-black"></div>}
                </div>
                <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">{label}</label>
            </div>
        </div>
    );
}

export default VisibleCheckBox;
